import { navigate } from 'gatsby'
import classNames from 'classnames'
import Text from 'components/Text'
import Button from 'components/Button'
import Carousel from './Carousel'
import router from 'utils/router'
import useOriginTheme from 'hooks/useOriginTheme'
import './LandingAdvantages.styl'

const LandingAdvantages = ({ blok, location }) => {
  const { isRecoveryOrigin } = useOriginTheme()

  const advantagesClassnames = classNames('landing-advantages-container', {
    'landing-advantages-container__generalTheme': !isRecoveryOrigin,
  })

  return (
    <div className={advantagesClassnames} id="PorqueRenegociar">
      <div className="landing-advantages-content">
        <Text h2 className="advantages-top-part">
          {blok.title}
        </Text>
        <div className="advantages-middle-part">
          <Carousel items={blok.advantages} />
        </div>
        <div className="advantages-bottom-part">
          <Button
            className="button"
            onClick={() => {
              if (typeof window !== 'undefined') {
                window.onbeforeunload = null
              }
              navigate('/registro', {
                state: {
                  source_url: location.href,
                  mp_uuid: router.getQueryString('mp_uuid'),
                },
              })
            }}
            data-unique="529c7349-e534-4bf4-a5c5-8cf8132adc9e"
          >
            {blok.button_text}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LandingAdvantages
